var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C12.2626 15.5005 12.5228 15.449 12.7654 15.3486C13.0081 15.2483 13.2285 15.1009 13.414 14.915L18.707 9.62103L17.293 8.20703L12 13.5L6.70703 8.20703L5.29303 9.62103L10.586 14.914C10.7715 15.1001 10.9919 15.2476 11.2345 15.3482C11.4772 15.4488 11.7374 15.5004 12 15.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.388ba93f03ed65cf00100cc9f92b9a71.svg";
export { ForwardRef as ReactComponent };